import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function SectionDescription(props) {
  const { classes } = props;
  return (
    <div className={classNames(classes.aboutDescription, classes.textCenter)}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <h2 className={classes.description}>
            REAL ESTATE INTELLIGENT VISION
          </h2>
          <h3>Services for builders, property developers and investors</h3>
          <h5>
            Kinos Land & New Homes we aim to simplify the process of buying and selling new homes and related properties including part exchange and assisted schemes.
Our strategy is to create partnerships with developers, builders, and all type of partners to support their objectives and add value to their businesses.
          </h5>
          <h5>We have refined our services and added new offerings.  is raising the bar and our commitment to world-class service for our clients, homebuyers, customers and partners, and much more.</h5>
          <h3>Innovation in an Industry that Never Stops Moving.</h3>
          <h5>Our combined estate agency businesses currently act for a large number of house builders throughout the Spain. Our services can be tailored to suit individual needs, from bespoke site sales and marketing, agency referral to the disposal of part exchange, assisted schemes and new build stock, land sales and acquisitions.</h5>
          <h3>Serving Successful Communities.</h3>
          <h5>Strategizing Every Step with our decades of experience as a full-service real estate marketing, sales and lease-up firm, we have configured a customizable yet definitive formula to achieve success. Every stage of the development lifecycle is meticulously planned and executed, abiding by market trends and forecasts to produce results. The groups within our team are highly specialized in each area, and work collaboratively to seamlessly transition between stages, striving for efficiency and distinguishing market solutions.</h5>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(descriptionStyle)(SectionDescription);
